import { useState } from 'react';
import { TableInput } from '../../../components/common';
import formatDate from '../../../components/common/formatDate';
import DatePickerMui from '../../../components/common/DatePickerMui';
import moment from 'moment';

interface Ifoot {
  moduleData: any;
  isView: boolean;
}
const TFoot = ({ moduleData, isView }: Ifoot) => {
  const [render, setRender] = useState(false);

  return (
    <tfoot>
      <tr>
        <th colSpan={2}>
          {' '}
          <TableInput
            name="prepared_by"
            type="text"
            value={moduleData.prepared_by}
            onChange={(e) => {
              moduleData.prepared_by = e.target.value;
              setRender((prev) => !prev);
            }}
            isView={isView}
          />
        </th>
        <th colSpan={1}>
          {' '}
          <TableInput
            name="approved_by"
            type="text"
            value={moduleData.approved_by}
            onChange={(e) => {
              moduleData.approved_by = e.target.value;
              setRender((prev) => !prev);
            }}
            isView={isView}
          />
        </th>
        <th colSpan={1}>
          <TableInput
            name="issued_by"
            type="text"
            value={moduleData.issued_by}
            onChange={(e) => {
              moduleData.issued_by = e.target.value;
              setRender((prev) => !prev);
            }}
            isView={isView}
          />
        </th>
        <th align="left">ISSUE NO :- </th>
        <th align="left">
          <TableInput
            name="issue_no"
            type="text"
            value={moduleData.issue_no}
            onChange={(e) => {
              moduleData.issue_no = e.target.value;
              setRender((prev) => !prev);
            }}
            isView={isView}
          />
        </th>
        <th colSpan={3} rowSpan={2} align="left">
          CONTROL SEAL:-{' '}
          <TableInput
            name="control_seal"
            type="text"
            value={moduleData.control_seal}
            onChange={(e) => {
              moduleData.control_seal = e.target.value;
              setRender((prev) => !prev);
            }}
            isView={isView}
          />
        </th>
      </tr>
      <tr>
        <th colSpan={2}>PREPARED BY </th>
        <th colSpan={1}>APPROVED BY </th>
        <th colSpan={1}>ISSUED BY (QA)</th>
        <th align="left">ISSUE DATE :- </th>
        <th align="left">
          {isView ? (
            formatDate(moduleData.issue_date)
          ) : (
            <DatePickerMui
              label=""
              value={moment(moduleData.issue_date)}
              onChange={(date) => {
                moduleData.issue_date = date;
                setRender((prev) => !prev);
              }}
            />
          )}
        </th>
      </tr>
      <tr>
        <th colSpan={9}>
          This document is valid only if printed through PC. Except sketch no
          Manual change / Overwriting allowed.
        </th>
      </tr>
      <tr>
        <th colSpan={2}>FORMAT NO:FM/QA/02</th>
        <th></th>
        <th colSpan={2}>Rev No-00</th>
        <th colSpan={4}></th>
      </tr>
    </tfoot>
  );
};

export default TFoot;
